import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'error-tooltip',
    templateUrl: './error-tooltip.component.html',
    styleUrls: ['./error-tooltip.component.css'],
    host: { class: 'invalid-tooltip' },
    standalone: false
})
export class ErrorTooltipComponent implements OnInit {
  @Input() errorMessages: string[];

  constructor() {}

  ngOnInit(): void {}
}
